import styled from 'styled-components';
export const Container = styled.div `
  width: min(100% - 2.5rem, 1280px);
  margin-inline: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: min(100% - 6rem, 1280px);
  }
`;
